import { removeNamespace } from '@piri/vue-utils';
import { assignReferenceArrayObject } from '@piri/utils';

import moduleName from './moduleName';
import mutationTypes from './types/mutationTypes';

const mutationTypesInModule = removeNamespace(moduleName, mutationTypes);

const authorsUpdated = (state, authors) => {
  assignReferenceArrayObject(state.authors, authors);
};

export default {
  [mutationTypesInModule.AUTHORS_UPDATED]: authorsUpdated,
};
